<script>
  export default {
    name: 'Yzxml',
    components: {
    },
    methods: {
    },
    created () {
    },
    data () {
      return {
      }
    },
    computed: {
    }
  }
</script>

<template>
  <div class="yzxml">
  <div class="margin-top-bar">
    <nav class="navbar navbar-expand navbar-secondary bg-light static-top fixed-top">
      <router-link class="navbar-brand mr-1 text-blue-dt"  to="/">Voltar</router-link>
    </nav>
  </div>
    <div class="jumbotron bg-secondary-dt">
      <div class="container">
        <h1 class="display-3 text-blue-dt">YzXml</h1>
        <h2 class="mb-4 text-secondary">O YzXML é um sistema de gerenciamento de documentos fiscais eletrônico.</h2>
        <p><a class="btn bg-blue-dt btn-lg" href="http://www.domtec.com.br" role="button">Saiba mais »</a></p>
      </div>
    </div>

      <div class="container m-top">
        <div class="row">
          <div class="col-md-10">
            <p>YzXML é um sistema para gerenciar documentos fiscais, é amplamente utilizado por contadores para monitorar documentos de seus clientes. <br>
                Dentro desse sistema é disponibilizado varias ferramentas para manipulação desses arquivos, ferramentas como gerenciar usuários, download dos documentos emitidos, etc. <br>
                <br>
                O sistema oferece suporte a vários tipos de documentos fiscais, sendo eles: NFe, CFe, CTe, NFSe ... <br>
                <br>
                Esse sistema se integra com o Yzidro ERP que é um software completo para alavancar a gestão da sua empresa. <br>
                <br>
                Cabe mencionar o excelente suporte oferecido pela nossa equipe de profissionais e a constante evolução da empresa, visando sempre oferecer o melhor produto aos nossos clientes.<br>
                <br>

                <a href="https://domtec.com.br/nossas-solucoes/"> Clique aqui para conhecer mais sobre nossos produtos e ferramentas. </a><br>
                <br>
                Email: <a href="mailto:comercial@domtec.com.br">comercial@domtec.com.br</a><br>
                Telefone: (14) 3662-5005 <br>
                Endereço: Avenida XV de Novembro, 1056 - Sala 3 Centro - Bariri - SP - CEP: 17250-000
            </p>
          </div>
        </div>
      </div>
  </div>
</template>

<style scoped>
  .bg-secondary-dt{background: #c6cee0!important}
</style>
